export const CARD_TEXT_PX_STORAGE_KEY = 'kds_card_text_px';
export const LEGACY_TEXT_SCALE_STORAGE_KEY = 'kds_card_text_scale';

export const CARD_TEXT_PX_DEFAULT = 14;
export const CARD_TEXT_PX_MIN = 10;
export const CARD_TEXT_PX_MAX = 120;
export const CARD_TEXT_PX_STEP = 1;

const CARD_DENSITY_IDS = ['normal', 'medium', 'large'];

const LEGACY_SCALE_TO_PX = {
  sm: 12,
  md: 14,
  lg: 16,
  xl: 18,
};

export const clampCardTextPx = (value) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return CARD_TEXT_PX_DEFAULT;
  return Math.min(CARD_TEXT_PX_MAX, Math.max(CARD_TEXT_PX_MIN, Math.round(parsed)));
};

/**
 * Soft layout scale so the card shell grows with text without exploding
 * (120px text would otherwise make cards ~8× taller).
 */
export const getCardLayoutScale = (px) => {
  const factor = clampCardTextPx(px) / CARD_TEXT_PX_DEFAULT;
  const soft = 1 + (factor - 1) * 0.72;
  return Math.min(2.2, Math.max(0.9, soft));
};

/** Layout mode for header stacking / readable kitchen cards. */
export const getCardDensityId = (px) => {
  const value = clampCardTextPx(px);
  if (value >= 24) return 'large';
  if (value >= 18) return 'medium';
  return 'normal';
};

export const getStoredCardTextPx = () => {
  try {
    const storedPx = localStorage.getItem(CARD_TEXT_PX_STORAGE_KEY);
    if (storedPx != null && storedPx !== '') {
      return clampCardTextPx(parseInt(storedPx, 10));
    }

    const legacy = localStorage.getItem(LEGACY_TEXT_SCALE_STORAGE_KEY);
    if (legacy && LEGACY_SCALE_TO_PX[legacy]) {
      return LEGACY_SCALE_TO_PX[legacy];
    }
  } catch {
    // localStorage may be blocked in private mode.
  }
  return CARD_TEXT_PX_DEFAULT;
};

export const applyCardTextPx = (value) => {
  const px = clampCardTextPx(value);
  const layout = getCardLayoutScale(px);
  const density = getCardDensityId(px);
  const root = document.documentElement;

  root.style.setProperty('--kd-card-base-px', String(px));
  root.style.setProperty('--kd-card-layout', String(layout));

  CARD_DENSITY_IDS.forEach((id) => {
    root.classList.remove(`kd-card-density-${id}`);
  });
  root.classList.add(`kd-card-density-${density}`);

  try {
    localStorage.setItem(CARD_TEXT_PX_STORAGE_KEY, String(px));
  } catch {
    // Ignore write failures.
  }

  return px;
};

export const stepCardTextPx = (current, direction) =>
  clampCardTextPx(current + direction * CARD_TEXT_PX_STEP);
